export default class Duty {
    public id?: number;
    public uid?: string;
    public code?: string;

    constructor(init?: Partial<Duty>) {
        Object.assign(this, init);
    }
}